module.exports = __webpack_public_path__ + "static/img/3.3affa40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/3.png
// module id = zrsB
// module chunks = 0